import React from 'react';
import { Box } from '@material-ui/core';
import { object, string } from 'prop-types';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import avonLogoRebrandingSvg from './Assets/avon-logo-rebranding.svg';
import justineLogoSvg from './Assets/justine_logo.svg';
import avonWhiteLogoLargeSvg from './Assets/avon_gradient.svg';
import avonWhiteLogoSvg from './Assets/avon-white-logo.svg';

const newSignupMrkts = ['EMPTY'];

const useStyles = makeStyles(theme => ({
  avonLogo: {
    background: p => (`url(${p.isNewSignup ? avonWhiteLogoSvg : avonLogoRebrandingSvg}) no-repeat center`),
    backgroundSize: 'contain',
    [theme.breakpoints.up('sm')]: {
      background: p => (`url(${p.isNewSignup ? avonWhiteLogoLargeSvg : avonLogoRebrandingSvg}) no-repeat center`),
    },
  },
  justineLogo: {
    background: `url(${justineLogoSvg}) no-repeat center`,
    backgroundSize: 'auto',
  },
  divide: {
    height: 3,
    marginTop: -3,
    background: 'linear-gradient(to right, #7F28C4 0%, #E2197C 64.421%, #E5231B 100%)',
  },
  justineDivide: {
    height: 3,
    marginTop: -3,
    background: 'linear-gradient(95.91deg, #F34831 0%, #F87A34 64.89%, #FFA51F 102.27%)',
  },
  heading: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: 24,
    lineHeight: '32px',
    textAlign: 'center',
    color: '#FFFFFF',
    margin: '24px 0 8px',
    [theme.breakpoints.up('sm')]: {
      fontFamily: 'Montserrat-Light',
      fontSize: 32,
      lineHeight: '42px',
    },
  },
  subheading: {
    fontFamily: 'Montserrat',
    fontSize: 16,
    lineHeight: '24px',
    textAlign: 'center',
    color: '#FFFFFF',
    [theme.breakpoints.up('sm')]: {
      fontFamily: 'Montserrat',
      fontSize: 14,
      lineHeight: '20px',
    },
  },
}));

const ConversionFlowHeader = ({ market, newSignupHeader }) => {
  const isNewSignup = newSignupMrkts.indexOf(market) > -1;
  const classes = useStyles({ isNewSignup });
  const theme = useTheme();
  const isNotMobile = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    // isNotMobile
    //   ? <AvonHeader />
    //   : (
    <Box
      component="div"
      mx="auto"
      data-testid="convFlowHeader"
      id="avonHeader-conv"
      style={isNewSignup ? { background: 'linear-gradient(131.14deg, #7F28C4 4.53%, #E2197C 70.61%, #E5231B 102.64%)', height: 420, padding: 24 } : {}}
    >
      {isNewSignup
        ? (
          <>
            <div className={theme.palette.colors.corePink === '#F37331' ? classes.justineLogo : classes.avonLogo} style={{ height: isNotMobile ? 32 : 20 }} />
            {
              newSignupHeader && (
                <>
                  <Box className={classes.heading}>{newSignupHeader.heading}</Box>
                  <Box className={classes.subheading}>{newSignupHeader.step}</Box>
                </>
              )
            }
          </>
        )
        : (
          <>
            <div
              className={
              (market === 'JT' || theme.palette.colors.corePink === '#F37331')
                ? classes.justineLogo : classes.avonLogo}
              style={{ height: isNotMobile ? 80 : 56 }}
            />
            <div className={
              (market === 'JT' || theme.palette.colors.corePink === '#F37331')
                ? classes.justineDivide : classes.divide}
            />
          </>
        )
      }
    </Box>
    // )
  );
};

ConversionFlowHeader.propTypes = {
  market: string,
  newSignupHeader: object,
};

export default ConversionFlowHeader;
